/**
 * Utility function to get USD/ARS exchange rate from Bluelytics API
 * @returns {Promise<number>} The blue dollar sell rate or 0 if error
 */
const getDolar = async () => {
   try {
      const response = await fetch(
         "https://api.bluelytics.com.ar/v2/latest"
      );
      
      if (!response.ok) {
         throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const dolar = await response.json();
      
      // Return the blue dollar sell value
      return dolar.blue.value_sell || 0;
      
   } catch (error) {
      console.error("Error fetching dollar rate:", error);
      return 0;
   }
};

// 👈 Export the function
export default getDolar;

// 👈 Alternative: Named export
// export { getDolar };

// 👈 You can also export additional utilities
export const getDolarCompra = async () => {
   try {
      const response = await fetch("https://api.bluelytics.com.ar/v2/latest");
      
      if (!response.ok) {
         throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const dolar = await response.json();
      return dolar.blue.value_buy || 0;
      
   } catch (error) {
      console.error("Error fetching dollar buy rate:", error);
      return 0;
   }
};

export const getOfficialDolar = async () => {
   try {
      const response = await fetch("https://api.bluelytics.com.ar/v2/latest");
      
      if (!response.ok) {
         throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const dolar = await response.json();
      return dolar.official.value_sell || 0;
      
   } catch (error) {
      console.error("Error fetching official dollar rate:", error);
      return 0;
   }
};

// 👈 Export all rates at once
export const getAllDolarRates = async () => {
   try {
      const response = await fetch("https://api.bluelytics.com.ar/v2/latest");
      
      if (!response.ok) {
         throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      return {
         blue: {
            buy: data.blue.value_buy || 0,
            sell: data.blue.value_sell || 0,
         },
         official: {
            buy: data.official.value_buy || 0,
            sell: data.official.value_sell || 0,
         },
         lastUpdate: data.last_update || null,
      };
      
   } catch (error) {
      console.error("Error fetching all dollar rates:", error);
      return {
         blue: { buy: 0, sell: 0 },
         official: { buy: 0, sell: 0 },
         lastUpdate: null,
      };
   }
};
   